export default __webpack_public_path__ + "7dc1f5c8448980c59f8a35dda585a8d3.png";